import { useCallback } from 'react';

import type { ShareActionsOptions, ShareChannel } from '#src/app/shared/hooks/share';

import { useCreateNewShare } from './useCreateNewShare';
import { useRedirect } from './useRedirect';
import { useTrackPromotionShare } from './useTrackPromotionShare';

type UseOnShareSuccessResult = {
	onSuccess: NonNullable<ShareActionsOptions['onSuccess']>;
	onShareTapped: NonNullable<ShareActionsOptions['onBeforeShare']>;
};

export function useOnShareSuccess(): UseOnShareSuccessResult {
	const trackPromotionShare = useTrackPromotionShare();
	const createNewShare = useCreateNewShare();
	const { redirect, onShareTapped } = useRedirect();

	return {
		onSuccess: useCallback(
			async (channel: ShareChannel) => {
				// awaiting to make sure it's done before navigating
				await Promise.all([trackPromotionShare(), createNewShare(channel)]);

				redirect(channel);
			},
			[trackPromotionShare, createNewShare, redirect],
		),
		onShareTapped,
	};
}
